import { render, staticRenderFns } from "./MarketBox.vue?vue&type=template&id=6fc49b96&"
import script from "./MarketBox.vue?vue&type=script&lang=js&"
export * from "./MarketBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports